import styled from 'styled-components'
import { Input } from 'antd'

export const StyledInput = styled(Input)`
  margin-top: 0.2em;
  margin-bottom: 1em;
`
